import { combineReducers } from "redux";
import { reducer as categoriesReducer } from "./Categories/reducer";
import { reducer as featuredDoctorsReducer } from "./Specialists/reducer";
import { reducer as testimonialsReducer } from "./Testimonials/reducer";
import { reducer as searchReducer, searchParamsReducer } from "./SearchEngine/reducer";
import { reducer as specialistReducer } from "./Specialist/reducer";
import { reducer as signupReducer } from "./Signup/reducer";
import { reducer as bookingReducer } from "./Booking/reducer";
import { reducer as userReducer } from "./User/reducer";
import { reducer as settingsReducer } from "./Settings/reducer";
import { reducer as rightPanel } from "./Panels/RightPanel/reducer";
import { reducer as myappointmentsReducer } from "./MyAppointments/reducer";
import { reducer as patientsReducer } from "./MyPatients/reducer";
import { chatReducer, reducer as chatsReducer } from "./Chats/reducer";
import { reducer as websocketReducer } from "./Websockets/reducer";
import { reducer as messagesReducer } from "./Messages/reducer";
import { reducer as dashboardReducer } from "./Dashboard/reducer";
import { reducer as mapReducer } from "./Map/reducer";
import { reducer as tableReducer } from "./DataTable/reducer";


const rootReducer = combineReducers({
    featuredDoctors: featuredDoctorsReducer,
    testimonials: testimonialsReducer,
    search: searchReducer,
    searchParameters: searchParamsReducer,
	categories: categoriesReducer,
    specialist: specialistReducer,
    signup: signupReducer,
    booking: bookingReducer,
    user: userReducer,
    settings: settingsReducer,
    rightPanel: rightPanel,
    myappointments: myappointmentsReducer,
    mypatients: patientsReducer,
    chats: chatsReducer,
    websocket: websocketReducer,
    messages: messagesReducer,
    dashboard: dashboardReducer,
    map: mapReducer,
    datatable: tableReducer,
    chathistory: chatReducer,
});

export default rootReducer;
